<template>
  <div>
    <div class="outline" style="max-width:600px; margin:80px auto;">
      <header class="w3-padding w3-dark-grey w3-center">
        <h4 style="display:inline-block; margin-left:3px;">Verify Email</h4>
      </header>
      <div class="w3-center">
        <br>
        <img src="@/assets/email_grey_192x192.png" alt="Avatar" style="width:25%" class="w3-circle w3-margin-top">
      </div>
      <div class="w3-container">
        <div class="w3-section w3-center">
          <p>Please check your email for a link to verify. We require this step before you will have access to the dashboard. Once you verify your email this message should disappear, or you can refresh the page to check again.</p>
          <button class="w3-btn w3-blue" @click.prevent="checkEmailVerification()" style="margin-top:5px; margin-right:15px;">Check Verification Status</button>
          <button class="w3-btn w3-red" @click.prevent="signOut()" style="margin-top:5px; margin-right:15px;">Sign Out</button>
          <button class="w3-btn w3-dark-grey" @click.prevent="resendEmail()" style="margin-top:5px;">Resend Email</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore';

export default {
  name: "verifyEmail",
  data() {
    return {
      state: dataStore.state
    };
  },
  methods: {
    signOut() {},
    resendEmail() {},
    checkEmailVerification() {
      dataStore.loginUser().then((res) => {
        console.log(this.state.user.status)
      })
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/verifyEmail.vue